import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PreSimulatorComponent } from './containers/pre-simulator/pre-simulator.component';

const routes: Routes = [
  {
    path: '',
    component: PreSimulatorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PreSimulatorRoutingModule {}
